export default {
  pages: {
    tour: {
      tabsLabel: "Detalhes do passeio",
      gallery: {
        label: "Galeria de fotos",
        position: "Foto {{n}} de {{total}}",
        expand: "Ampliar",
        dialog: "Fotos em tela cheia",
      },
    },
    legalNav: "Outras políticas",
    cart: {
      summary: "Resumo da reserva",
    },
    paymentReturn: {
      reservation: "Reserva",
    },
    notFound: {
      seoTitle: 'Página Não Encontrada',
    },
    category: {
      notFoundTitle: 'Categoria não encontrada',
      subtitles: {
        escunas:
          'Navegue pelas águas cristalinas de Paraty a bordo de escunas tradicionais e de luxo. Passeios compartilhados ou privativos, com paradas em praias paradisíacas.',
        privadas:
          'Exclusividade total para seu grupo. Escolha o roteiro, o ritmo e aproveite as praias de Paraty sem multidões a bordo de lanchas confortáveis.',
        compartilhadas:
          'Aventuras em grupo pelas águas de Paraty. Passeios de lancha compartilhada com preços acessíveis e experiências inesquecíveis.',
        jeep:
          'Aventure-se pela Mata Atlântica, cachoeiras, alambiques e a Estrada Real de Paraty em emocionantes passeios de jeep 4x4.',
        bolivia:
          'Descubra o maior deserto de sal do mundo! Expedições inesquecíveis pelo Altiplano Boliviano — Salar de Uyuni, lagoas coloridas, gêiseres, vulcões e paisagens surreais.',
      },
    },
    about: {
      title: 'Sobre Nós',
      whoTitle: 'Quem somos',
      whoText:
        'A AQUAMARINA TOURS oferece experiências de passeio em Paraty, com foco em rotas de mar, natureza, praias, ilhas e paisagens da Costa Verde. A operação combina passeios com atenção ao roteiro, conforto e segurança durante a experiência.',
      whereTitle: 'Onde atuamos',
      whereText:
        'Nossa atuação está concentrada em Paraty e região, incluindo rotas da baía, praias, pontos de mergulho, trilhas e experiências de passeio em embarcações e veículos 4x4.',
      proposalTitle: 'Nossa proposta',
      proposalText1:
        'A proposta da AQUAMARINA TOURS é proporcionar roteiros que conectem mar, paisagens e cultura local, com foco em experiências autênticas e bem organizadas para visitantes, grupos e famílias.',
      proposalText2:
        'Para informações específicas sobre cada passeio, duração, ponto de encontro, condições e disponibilidade, consulte a página do passeio desejado ou entre em contato diretamente.',
    },
    contact: {
      title: 'Contato',
      talkTitle: 'Fale conosco',
      whatsapp: 'WhatsApp',
      phone: 'Telefone',
      email: 'E-mail',
      location: 'Localização',
      locationValue: 'Paraty, RJ — Brasil',
      howTitle: 'Como reservar',
      howText:
        'Para reservar ou confirmar disponibilidade, entre em contato pelo WhatsApp, telefone ou use o formulário disponível na seção de contato do site. Informe a data desejada, quantidade de pessoas e o passeio de interesse.',
      hoursText:
        'Horário de atendimento: todos os dias, das 8h30 às 22h. Fora desse horário, sua mensagem será respondida assim que a equipe estiver disponível.',
    },
    legal: {
      privacy: {
        heading: 'Política de Privacidade',
        body: [
          'A AQUAMARINA TOURS coleta e utiliza dados apenas para fins de atendimento, contato, reserva e prestação do serviço solicitado.',
          'Os dados podem incluir nome, contato, informações de reserva e mensagens enviadas por formulário, WhatsApp ou outros canais de comunicação.',
          'No site podem existir ferramentas externas de análise, hospedagem e contato, conforme a tecnologia realmente utilizada. Os dados não serão compartilhados com terceiros além dos prestadores necessários para a operação do serviço.',
          'O usuário pode solicitar esclarecimentos, correção ou exclusão de dados conforme a legislação aplicável pelo e-mail paraty.sirenatours@gmail.com ou pelo WhatsApp +55 11 95245-1307.',
        ],
      },
      cookies: {
        heading: 'Política de Cookies',
        body: [
          'Atualmente, o site utiliza apenas tecnologias necessárias para carregar a aplicação, manter a navegação e disponibilizar os recursos solicitados pelo usuário.',
          'No momento, a AQUAMARINA TOURS não configurou Google Analytics, Google Tag Manager ou cookies de publicidade no site.',
          'Se novas ferramentas analíticas ou publicitárias forem instaladas, esta política será atualizada e o consentimento será solicitado quando exigido pela legislação aplicável.',
          'O usuário também pode controlar ou apagar cookies pelas configurações do próprio navegador.',
        ],
      },
      terms: {
        heading: 'Termos e Condições',
        seller: {
          title: 'Dados legais do vendedor',
          name: 'Nome completo',
          document: 'Documento de identidade',
          brand: 'Nome comercial',
          address: 'Endereço de atendimento',
          email: 'E-mail',
          whatsapp: 'WhatsApp',
        },
        body: [
          'Estes Termos e Condições regem a compra de passeios turísticos no site aquamarinatours.art. A venda é feita por {{sellerName}}, documento de identidade n.º {{sellerDocument}}, sob o nome comercial AQUAMARINA TOURS, com atendimento em Paraty, RJ, Brasil.',
          'Ao fazer uma reserva ou um pagamento no site, o cliente declara ter lido e aceito estes termos, a Política de Reservas, a Política de Cancelamentos e a Política de Privacidade.',
          'O site vende reservas de passeios em Paraty e região (escunas, lanchas, passeios de jeep e outras experiências). Os passeios são realizados por embarcações, veículos e guias de operadores locais; a AQUAMARINA TOURS é responsável pela venda, pela reserva e pelo atendimento ao cliente antes e depois do passeio.',
          'Os preços são exibidos em reais (R$), por pessoa ou pela embarcação ou grupo inteiro, conforme indicado em cada passeio. Os valores de crianças e bebês, o que está incluído e o que não está incluído aparecem na página de cada passeio. O total, o sinal e o restante são mostrados antes do pagamento.',
          'Nos passeios com reserva online, o cliente paga agora um sinal (a porcentagem aparece no resumo antes do pagamento) por Pix ou cartão de crédito, e o restante, se houver, no dia do passeio. Os pagamentos online são processados por plataformas de pagamento seguras, como o Mercado Pago; os dados do cartão são digitados no formulário da plataforma e não são armazenados pela AQUAMARINA TOURS.',
          'Alguns passeios, como os privativos, são reservados por cotação pelo WhatsApp: nenhum valor é cobrado no site, e o preço e as condições são combinados por escrito antes do pagamento.',
          'A reserva fica confirmada quando o pagamento do sinal é aprovado. Em seguida, o cliente recebe por e-mail os dados da reserva e as instruções do passeio. Uma reserva com Pix não pago dentro do prazo indicado no pagamento é cancelada automaticamente, sem custo.',
          'Em casos excepcionais, como uma vaga ocupada no mesmo instante por outro cliente, a reserva pode ficar em análise. Se não for possível confirmá-la, o cliente é avisado e recebe a devolução integral do valor pago.',
          'Cancelamento pelo cliente com 7 dias ou mais de antecedência: reembolso de 100% do valor pago. Entre 7 dias e 48 horas antes: reembolso de 80%. Com menos de 48 horas ou não comparecimento: sem reembolso. Os reembolsos são feitos pelo mesmo meio de pagamento utilizado. Detalhes na Política de Cancelamentos.',
          'O operador pode alterar, adiar ou cancelar o passeio por condições climáticas, de segurança ou por determinação das autoridades (como a Marinha do Brasil). Nesses casos, o cliente escolhe entre remarcar sem custo ou receber o reembolso de 100% do valor pago.',
          'O cliente deve informar dados corretos (nome, e-mail, telefone e documento), chegar ao ponto de encontro no horário indicado, apresentar documento de identificação quando solicitado e seguir as orientações da tripulação e dos guias. Menores de idade devem estar acompanhados de um responsável.',
          'Os dados pessoais informados são usados apenas para a reserva, o pagamento, o atendimento e o envio da confirmação, conforme a Política de Privacidade e a Lei Geral de Proteção de Dados (LGPD).',
          'Dúvidas, alterações e reclamações: e-mail {{email}} ou WhatsApp {{phone}}.',
          'Estes termos seguem a legislação brasileira, em especial o Código de Defesa do Consumidor. Fica eleito o foro do domicílio do consumidor para resolver eventuais conflitos.',
          'A AQUAMARINA TOURS pode atualizar estes termos; vale sempre a versão publicada no momento da compra.',
        ],
        updated: 'Última atualização: 27 de outubro de 2026.',
        acceptNote: 'Ao pagar, você aceita os <terms>Termos e Condições</terms> e a <cancel>Política de Cancelamentos</cancel>.',
      },
      reservations: {
        heading: 'Política de Reservas',
        body: [
          'As reservas podem ser confirmadas mediante contato com a AQUAMARINA TOURS por WhatsApp, telefone ou canal indicado no site.',
          'Antes da confirmação final, devem ser verificadas disponibilidade, data, itinerário, ponto de encontro e condições específicas do passeio.',
          'A reserva é confirmada quando o cliente paga um sinal de 20% do valor total do passeio.',
          'O pagamento pode ser realizado via PIX ou cartão de crédito, incluindo Visa e Mastercard, conforme orientação da equipe de atendimento.',
          'Após a confirmação do sinal, a equipe enviará as informações da reserva e do passeio pelo canal de atendimento utilizado.',
        ],
      },
      cancellations: {
        heading: 'Política de Cancelamentos',
        body: [
          'Os cancelamentos devem ser comunicados pela forma acordada com a AQUAMARINA TOURS.',
          'Cancelamento com 7 dias ou mais de antecedência: reembolso de 100% do valor pago.',
          'Cancelamento entre 7 dias e 48 horas antes do passeio: retenção de 20% do valor pago e reembolso de 80%.',
          'Cancelamento com menos de 48 horas ou não comparecimento (no-show): não haverá reembolso.',
          'Em caso de cancelamento pela empresa por motivos de segurança, condições climáticas ou operacionais, o cliente poderá remarcar o passeio ou receber o reembolso de 100% do valor pago.',
          'Esta política segue o Código de Defesa do Consumidor e a legislação brasileira aplicável.',
        ],
      },
    },
  },
};
